import { currencyFormatter } from '../utils/reportingUtils';

const formatEventDate = (value) => {
  if (!value) return '';
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatCell = (type, value) => {
  if (value === null || value === undefined || value === '') return '';
  switch (type) {
    case 'currency':
      return currencyFormatter.format(Number(value) || 0);
    case 'percent':
      return `${(Number(value) || 0).toFixed(1)}%`;
    case 'date':
      return formatEventDate(value);
    case 'integer':
      return (Number(value) || 0).toLocaleString('en-US');
    default:
      return value;
  }
};
